import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';

const AuditingDashboard = lazy(() => import('../components/auditing/AuditingDashboard'));
const RevolutAuditing = lazy(() => import('../components/auditing/RevolutAuditing'));
const EasyUploads = lazy(() => import('../components/auditing/EasyUploads'));
const AmazonAuditing = lazy(() => import('../components/auditing/AmazonAuditing'));
const EbayAuditing = lazy(() => import('../components/auditing/EbayAuditing'));
const ShopifyAuditing = lazy(() => import('../components/auditing/ShopifyAuditing'));

export const auditingRoutes = (
  <>
    <Route path="/auditing" element={<Navigate to="/auditing/dashboard" replace />} />
    <Route path="/auditing/dashboard" element={<AuditingDashboard />} />
    <Route path="/auditing/revolut" element={<RevolutAuditing />} />
    <Route path="/auditing/amazon" element={<AmazonAuditing />} />
    <Route path="/auditing/ebay" element={<EbayAuditing />} />
    <Route path="/auditing/shopify" element={<ShopifyAuditing />} />
    <Route path="/auditing/easy-uploads" element={<EasyUploads />} />
  </>
);
